/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  CashBalancePayload,
  FailureResponseResponse,
  NotFoundResponse,
  Success,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Returns last cash balance declaration of an accounting location
 * @summary Latest cash count calculation an accounting location
 */
export const postCalculateCashDeclaration = (cashBalancePayload: CashBalancePayload) => {
  return customInstance<Success>({
    url: `/BboCashManagementService/v1/cash-declaration/calculate-accounting-location`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: cashBalancePayload,
  });
};

export const getPostCalculateCashDeclarationMutationOptions = <
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCalculateCashDeclaration>>,
    TError,
    { data: CashBalancePayload },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCalculateCashDeclaration>>,
  TError,
  { data: CashBalancePayload },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCalculateCashDeclaration>>,
    { data: CashBalancePayload }
  > = (props) => {
    const { data } = props ?? {};

    return postCalculateCashDeclaration(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCalculateCashDeclarationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCalculateCashDeclaration>>
>;
export type PostCalculateCashDeclarationMutationBody = CashBalancePayload;
export type PostCalculateCashDeclarationMutationError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Latest cash count calculation an accounting location
 */
export const usePostCalculateCashDeclaration = <
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCalculateCashDeclaration>>,
    TError,
    { data: CashBalancePayload },
    TContext
  >;
}) => {
  const mutationOptions = getPostCalculateCashDeclarationMutationOptions(options);

  return useMutation(mutationOptions);
};
